import { render, staticRenderFns } from "./OpenAI.vue?vue&type=template&id=1140f61e&scoped=true"
import script from "./OpenAI.vue?vue&type=script&lang=js"
export * from "./OpenAI.vue?vue&type=script&lang=js"
import style0 from "./OpenAI.vue?vue&type=style&index=0&id=1140f61e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1140f61e",
  null
  
)

export default component.exports